import API from "../utils/api";
import constant from '../../constants/constant';
import UtilService from '../utils/utils';
import {
  API_START,
  API_SUCCESS,
  API_FAIL,
  ROUND_ROBIN_START,
  ROUND_ROBIN_SUCCESS,
  ROUND_ROBIN_FAIL,
  TOURNAMENT_LIST_START,
  TOURNAMENT_LIST_SUCCESS,
  TOURNAMENT_LIST_FAIL,
  DELETE_ROW_START,
  DELETE_ROW_SUCCESS,
  DELETE_ROW_FAIL,
  KNOCKOUT_START,
  KNOCKOUT_SUCCESS,
  KNOCKOUT_FAIL,
  TOURNAMENT_MATCH_DETAILS_START,
  TOURNAMENT_MATCH_DETAILS_SUCCESS,
  TOURNAMENT_MATCH_DETAILS_FAIL,
  DELETE_MATCH_SUCCESS,
  DELETE_MATCH_FAIL,
  DELETE_MATCH_START,
  INITIATE_PAYMENT_START,
  INITIATE_PAYMENT_SUCCESS,
  INITIATE_PAYMENT_FAIL,
  INITIATE_MYTRANSACTION_START,
  INITIATE_MYTRANSACTION_SUCCESS,
  INITIATE_MYTRANSACTION_FAIL,
  ADD_FRAME_SCORE_START,
  ADD_FRAME_SCORE_SUCCESS,
  ADD_FRAME_SCORE_FAIL,
  ADD_PLAYER_TOURNAMENT_START,
  ADD_PLAYER_TOURNAMENT_SUCCESS,
  ADD_PLAYER_TOURNAMENT_FAIL,
  UPCOMING_TOURNAMENT_LIST_START,
  UPCOMING_TOURNAMENT_LIST_SUCCESS,
  UPCOMING_TOURNAMENT_LIST_FAIL,
  REMOVE_SELF_ENTRY_START,
  REMOVE_SELF_ENTRY_SUCCESS,
  REMOVE_SELF_ENTRY_FAIL
} from "../../constants/type";
import config from "../../constants/config";
import { toast } from "react-toastify";
import { data } from "jquery";
import { cloneDeep } from 'lodash';
// import constant from "../../constants/constant";

export const actionScheduleRoundRobin = (dataParams) => {
  return async function (dispatch) {
    dispatch({ type: ROUND_ROBIN_START });

    await API.postRequest(`${config.BASE_URL}/tournament`, dataParams)
      .then(response => {
        dispatch({
          type: ROUND_ROBIN_SUCCESS,
          payload: response
        });
        //console.log("Create New Match response ----->>>", response);

      })
      .catch(error => {
        //console.log("Create New Match Error *********", error);
        if (error.response) {
          return dispatch({ type: ROUND_ROBIN_FAIL, payload: error.response });
        } else {
          return dispatch({ type: ROUND_ROBIN_FAIL, payload: error });
        }

      });
  };
}

export const getTournamentListing = (data) => {
  return async function (dispatch) {
    dispatch({ type: TOURNAMENT_LIST_START });
    let requestPayload = '';

    let clubQuery = '';
    if (data.clubIdVal) {
      clubQuery = `&clubId=${data.clubIdVal}`;
    } else {
      let clubsListArr = UtilService.getInfoFromStorage('localStorage', constant.CLUBS);
      if (clubsListArr && clubsListArr.length > 0) {
        clubQuery = `&clubId=${clubsListArr[0].clubId}`;
      }
    }
    if (data && data.hasOwnProperty('valueKey')) {
      requestPayload = `?tournamentName=` + data.valueKey + clubQuery;
    } else {
      requestPayload = `?limit=` + config.PAGE_SIZE_20 + `&pageNumber=` + data.activePage + `&tournamentName=` + data.searchBy.tournamentName + `&startDate=` + data.searchBy.date + `&statusId=` + data.searchBy.statusId + clubQuery
    }
    await API.getRequest(`${config.BASE_URL}/tournament/manage` + requestPayload)
      .then(response => {
        dispatch({
          type: TOURNAMENT_LIST_SUCCESS,
          payload: response
        });
        //console.log("Create New Match response ----->>>", response);

      })
      .catch(error => {
        //console.log("Create New Match Error *********", error);
        if (error.response) {
          return dispatch({ type: TOURNAMENT_LIST_FAIL, payload: error.response });
        } else {
          return dispatch({ type: TOURNAMENT_LIST_FAIL, payload: error });
        }

      });
  };
}

export const deleteTournamentAction = (deleteId) => {
  return function (dispatch) {
    dispatch({ type: DELETE_ROW_START });
    //console.log("----------------------------", clubId)
    //return
    API.deleteRequest(`${config.BASE_URL}/tournament/` + deleteId)
      .then(response => {
        //success API response
        //console.log("****************", response)
        return dispatch({
          type: DELETE_ROW_SUCCESS,
          payload: response
        });
      })
      .catch(error => {
        //failed Api response
        return dispatch({ type: DELETE_ROW_FAIL, payload: error });
      });
  }
}

export const deleteMatchAction = (matchId) => {

  return async function (dispatch) {
    dispatch({ type: DELETE_MATCH_START });

    await API.deleteRequest(`${config.BASE_URL}/match/` + matchId)
      .then(response => {
        return dispatch({
          type: DELETE_MATCH_SUCCESS,
          payload: response
        });
      })
      .catch(error => {
        return dispatch({ type: DELETE_MATCH_FAIL, payload: error });
      });
  }
}

export const actionKnockout = (dataParams) => {
  if (dataParams.Rounds[0]) {
    dataParams.tournamentId = dataParams.Rounds[0].tournamentId ? dataParams.Rounds[0].tournamentId : '';
  } else {
    dataParams.tournamentId = ''
  }
  let req = cloneDeep(dataParams);

  req.Rounds = [
    {
      "roundName": "Round 1",
      "Matches": []
    }
  ]

  return async function (dispatch) {
    dispatch({ type: KNOCKOUT_START });

    // console.log("Knockout Service data response ----->>>", dataParams);
    // return

    await API.postRequest(`${config.BASE_URL}/tournament`, req)
      .then(response => {
        dispatch({
          type: KNOCKOUT_SUCCESS,
          payload: response
        });
        //console.log("Create New Match response ----->>>", response);

      })
      .catch(error => {
        //console.log("Create New Match Error *********", error);
        if (error.response) {
          return dispatch({ type: KNOCKOUT_FAIL, payload: error.response });
        } else {
          return dispatch({ type: KNOCKOUT_FAIL, payload: error });
        }

      });
  };
}

export const actionKnockoutUpdate = (dataParams) => {

  return function (dispatch) {
    dispatch({ type: KNOCKOUT_START });

    // console.log("Knockout Service data response ----->>>", dataParams);
    // return

    API.postRequest(`${config.BASE_URL}/tournament`, dataParams)
      .then(response => {
        dispatch({
          type: KNOCKOUT_SUCCESS,
          payload: response
        });
        //console.log("Create New Match response ----->>>", response);
      })

      .catch(error => {
        //console.log("Create New Match Error *********", error);
        if (error.response) {
          return dispatch({ type: KNOCKOUT_FAIL, payload: error.response });
        } else {
          return dispatch({ type: KNOCKOUT_FAIL, payload: error });
        }

      });
  };
}

export const actionRoundRobinUpdate = (dataParams) => {

  return async function (dispatch) {
    dispatch({ type: KNOCKOUT_START });

    // console.log("Knockout Service data response ----->>>", dataParams);
    // return

    await API.putRequest(`${config.BASE_URL}/tournament/roundrobin`, dataParams)
      .then(response => {
        dispatch({
          type: KNOCKOUT_SUCCESS,
          payload: response
        });
        //console.log("Create New Match response ----->>>", response);
      })

      .catch(error => {
        console.log("Create New Match Error *********", error.message);
        toast.warn(error?.response?.data?.message ? error?.response?.data?.message : "Something went wrong")
        if (error.response) {
          return dispatch({ type: KNOCKOUT_FAIL, payload: error.response });
        }

      });
  };
}

export const getSingleTournamentDetails = (history, id, type) => {
  return async function (dispatch) {
    dispatch({ type: TOURNAMENT_MATCH_DETAILS_START });

    // let requestPayload = config.PAGE_SIZE + `&pageNumber=` + data.activePage + `&tournamentName=` + data.searchBy.tournamentName + `&startDate=` + data.searchBy.date + `&statusId=` + data.searchBy.statusId

   await API.getRequest(`${config.BASE_URL}/tournament/` + id)
      .then(response => {
        dispatch({
          type: TOURNAMENT_MATCH_DETAILS_SUCCESS,
          payload: response
        });
        history.push({ pathname: '/create-tournament', state: { detail: response, layoutView: type } })
        //console.log("Create New Match response ----->>>", response);

      })
      .catch(error => {
        //console.log("Create New Match Error *********", error);
        if (error.response) {
          return dispatch({ type: TOURNAMENT_MATCH_DETAILS_FAIL, payload: error.response });
        } else {
          return dispatch({ type: TOURNAMENT_MATCH_DETAILS_FAIL, payload: error });
        }

      });
  };
}

export const updateSingleRow = (dataParams) => {
  return function (dispatch) {
    dispatch({ type: KNOCKOUT_START });

    // console.log("Knockout Service data response ----->>>", dataParams);
    // return

    API.putRequest(`${config.BASE_URL}/tournament`, dataParams)
      .then(response => {
        dispatch({
          type: KNOCKOUT_SUCCESS,
          payload: response
        });
        //console.log("Create New Match response ----->>>", response);

      })
      .catch(error => {
        //console.log("Create New Match Error *********", error);
        if (error.response) {
          return dispatch({ type: KNOCKOUT_FAIL, payload: error.response });
        } else {
          return dispatch({ type: KNOCKOUT_FAIL, payload: error });
        }

      });
  };
}

export const actionCreateScheduleRoundRobin = (dataParams) => {
  return async function (dispatch) {
    dispatch({ type: ROUND_ROBIN_START });

    await API.postRequest(`${config.BASE_URL}/tournament/roundrobin`, dataParams)
      .then(response => {
        dispatch({
          type: ROUND_ROBIN_SUCCESS,
          payload: response
        });
        //console.log("Create New Match response ----->>>", response);

      })
      .catch(error => {
        //console.log("Create New Match Error *********", error);
        if (error.response) {
          return dispatch({ type: ROUND_ROBIN_FAIL, payload: error.response });
        } else {
          return dispatch({ type: ROUND_ROBIN_FAIL, payload: error });
        }

      });
  };
}

export const actionCreateScheduleKnockout = (dataParams) => {
  return async function (dispatch) {
    dispatch({ type: ROUND_ROBIN_START });

    await API.postRequest(`${config.BASE_URL}/tournament/knockout`, dataParams)
      .then(response => {
        dispatch({
          type: ROUND_ROBIN_SUCCESS,
          payload: response
        });
        //console.log("Create New Match response ----->>>", response);

      })
      .catch(error => {
        //console.log("Create New Match Error *********", error);
        if (error.response) {
          return dispatch({ type: ROUND_ROBIN_FAIL, payload: error.response });
        } else {
          return dispatch({ type: ROUND_ROBIN_FAIL, payload: error });
        }

      });
  };
}


export const getPaymentMemberDetailsByTournamentId = (id) => {
  return async function (dispatch) {

    dispatch({ type: API_START });
    await API.getRequest(`${config.BASE_URL}/tournament/${id}/players`)
      .then(response => {
        dispatch({ type: API_SUCCESS, payload: response });
      })
      .catch(error => {
        if (error.response && (error.response.status === 500 || error.response.status === 400)) {
          return dispatch({
            type: API_FAIL,
            payload: error.response.data.message
          });
        }
        else
          dispatch({
            type: API_FAIL,
            payload: error
          });
      });

  }
}

export const paymentInitiateMembers = (dataParams) => {
  return async function (dispatch) {

    dispatch({ type: INITIATE_PAYMENT_START });
    await API.postRequest(`${config.BASE_URL}/payment/member`, dataParams)
      .then(response => {
        dispatch({ type: INITIATE_PAYMENT_SUCCESS, payload: response });
      })
      .catch(error => {
        if (error.response && (error.response.status === 500 || error.response.status === 400)) {
          return dispatch({
            type: INITIATE_PAYMENT_FAIL,
            payload: error.response.data.message
          });
        }
        else
          dispatch({
            type: API_FAIL,
            payload: error
          });
      });

  }
}

export const getMyTransactionDetails = (dataParams) => {
  return async function (dispatch) {
    dispatch({ type: INITIATE_MYTRANSACTION_START });
    // let clubId = ''
    let searchQuery = '';
    if (dataParams.clubId) {
      searchQuery = `&clubId=${dataParams.clubId}`;
    }
    if (dataParams.tournamentId) {
      searchQuery = searchQuery + `&tournamentId=${dataParams.tournamentId}`;
    }
    if (dataParams.chargeTo) {
      searchQuery = searchQuery + `&chargeTo=${dataParams.chargeTo}`;
    }
    if (dataParams.fromDate) {
      searchQuery = searchQuery + `&fromDate=${dataParams.fromDate}`;
    }

    if (dataParams.toDate) {
      searchQuery = searchQuery + `&toDate=${dataParams.toDate}`;
    }

    if (dataParams.status) {
      searchQuery = searchQuery + `&status=${dataParams.status}`;
    }

    if (dataParams.memberId) {
      searchQuery = searchQuery + `&memberId=${dataParams.memberId}`;
    }

    if (dataParams.memberName) {
      searchQuery = searchQuery + `&memberName=${dataParams.memberName}`;
    }
    if (dataParams.sponserBy) {
      searchQuery = searchQuery + `&sponserBy=${dataParams.sponserBy}`;
    }

    if (dataParams.transactionType) {
      searchQuery = searchQuery + `&transactionType=${dataParams.transactionType}`;
    }

    await API.getRequest(`${config.BASE_URL}/payment/transactions/report?limit=${config.PAGE_SIZE}&pageNumber=${dataParams.activePage}${searchQuery}`)
      .then(response => {
        dispatch({ type: INITIATE_MYTRANSACTION_SUCCESS, payload: response });
      })
      .catch(error => {
        if (error.response && (error.response.status === 500 || error.response.status === 400)) {
          return dispatch({
            type: INITIATE_MYTRANSACTION_FAIL,
            payload: error.response.data.message
          });
        }
        else
          dispatch({
            type: API_FAIL,
            payload: error
          });
      });

  }
}

export const addFrameScoresAction = (dataParams, id, history) => {
  return async function (dispatch) {
    dispatch({ type: ADD_FRAME_SCORE_START });

   await API.putRequest(`${config.BASE_URL}/match/updateFrameScores`, dataParams)
      .then(response => {
        dispatch({
          type: ADD_FRAME_SCORE_SUCCESS,
          payload: response
        });
        toast.success("The match score has been updated successfully.");
      })
      .catch(error => {
        toast.error(error?.response?.data?.message ?error.response.data.message:"Something went wrong");
        if (error.response) {          
          return dispatch({ type: ADD_FRAME_SCORE_FAIL, payload: error.response });
        } else {
          return dispatch({ type: ADD_FRAME_SCORE_FAIL, payload: error });
        }

      });
  };
}


export const getTournamentListToEnterPlayer = (data) => {
  return async function (dispatch) {
    dispatch({ type: UPCOMING_TOURNAMENT_LIST_START });

    let requestPayload = `?limit=` + 8 + `&pageNumber=` + data.activePage + `&statusId=` + 1;
    if (data.clubId) {
        requestPayload += `&clubId=` + data.clubId;
    }
    if (data.tournamentName) {
        requestPayload += `&tournamentName=` + data.tournamentName;
    }
    if (data.date) {
        requestPayload +=  `&startDate=` + data.date;
    }   
    if (data.sportType) {
        requestPayload += `&sportType=` + data.sportType;
    } 
    if (data.tournamentStyle) {
      requestPayload += `&tournamentStyle=` + data.tournamentStyle;
  } 
    //  requestPayload = `?limit=` + config.PAGE_SIZE + `&pageNumber=` + data.activePage + `&tournamentName=` + data.tournamentName + `&startDate=` + data.date + `&statusId=` + data.statusId + `&clubId=` + data.clubId
        await API.getRequest(`${config.BASE_URL}/tournament/upcoming` + requestPayload)
      .then(response => {
        dispatch({
          type: UPCOMING_TOURNAMENT_LIST_SUCCESS,
          payload: response
        });
      })
      .catch(error => {
        if (error.response) {
          return dispatch({ type: UPCOMING_TOURNAMENT_LIST_FAIL, payload: error.response });
        } else {
          return dispatch({ type: UPCOMING_TOURNAMENT_LIST_FAIL, payload: error });
        }

      });
  };
}

export const addPlayerInTournament = (dataParams) => {
  return async function (dispatch) {
    dispatch({ type: ADD_PLAYER_TOURNAMENT_START });

    await API.postRequest(`${config.BASE_URL}/tournament/addPlayer`, dataParams)
      .then(response => {
        dispatch({
          type: ADD_PLAYER_TOURNAMENT_SUCCESS,
          payload: response
        });
      })
      .catch(error => {
        if (error.response) {
          return dispatch({ type: ADD_PLAYER_TOURNAMENT_FAIL, payload: error.response });
        } else {
          return dispatch({ type: ADD_PLAYER_TOURNAMENT_FAIL, payload: error });
        }

      });
  };
}

export const toLeaveTournamentAPI = (tournamentId, playerId) => {
  return async function (dispatch) {
    dispatch({ type: REMOVE_SELF_ENTRY_START });

    await API.postRequest(`${config.BASE_URL}/${tournamentId}/remove-self-entry/${playerId}`)
      .then(response => {
        dispatch({
          type: REMOVE_SELF_ENTRY_SUCCESS,
          payload: response
        });
      })
      .catch(error => {
        if (error.response) {
          return dispatch({ type: REMOVE_SELF_ENTRY_FAIL, payload: error.response });
        } else {
          return dispatch({ type: REMOVE_SELF_ENTRY_FAIL, payload: error });
        }
      });
  };
}